module.exports = __webpack_public_path__ + "static/media/fundrise-logo.90d8f894.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/companies/fundrise-logo.svg
 ** module id = 426
 ** module chunks = 0
 **/